export const CUSTOMER_SEARCH_TYPES = {
  phoneNumber: 'phone-number',
  customerIdentifier: 'customer-identifier',
  emailAddress: 'email-address',
  zipFnameLname: 'zip-fname-lname',
};

export const ORDER_SEARCH_TYPES = {
  orderId: 'SearchByOrderId',
  recipient: 'SearchOrdersByRecipient',
  orderQueues: 'SearchOrderQueues',
};

export const CUSTOMER_SEARCH_RECORDS_KEYS = {
  accountNumber: 'accountNumber',
  divisions: 'divisions',
  lastName: 'lastName',
  firstName: 'firstName',
  addressLine1: 'addressLine1',
  zipCode: 'zipCode',
  emailAddress: 'emailAddress',
  phoneNumber: 'phoneNumber',
};

export const ORDER_SEARCH_RECORDS_KEYS = {
  orderId: 'orderId',
  status: 'status',
  total: 'total',
  numberOfItems: 'numberOfItems',
  paymentMethod: 'paymentMethod',
  lastModified: 'lastModified',
  origin: 'origin',
  customerName: 'customerName',
  address: 'address',
  lastName: 'lastName',
  firstName: 'firstName',
  orderDate: 'orderDate',
  division: 'division',
  orderStatus: 'orderStatus',
  orderAmount: 'orderAmount',
  channel: 'channel',
  lastAttemptDate: 'lastAttemptDate',
  orderTerms: 'orderTerms',
};
